import { Injectable } from '@angular/core';
import { BagItems } from "../../booking/models/booking-reducer.interface";

enum ItemTypes {
    bags = 1,
    childEquipment,
    oversizeItem
}

@Injectable({
    providedIn: 'root'
})
export class BagItemsService {

    getTotalItems(bagItems) {
        let items = 0;
        if (bagItems) {
            Object.keys(bagItems).forEach(item => {
                items += bagItems[item]
            });
        }
        return items;
    }

    checkForbagItemsChange(prev, current) {
        const keys = Object.keys(prev);
        let hasChanged = false;
        for (let i = 0; i < keys.length; i++) {
            if (prev[keys[i]] !== current[keys[i]]) {
                hasChanged = true;
            }
        }
        return hasChanged;
    }

    checkForEmptybagItems(bagItems) {
        const keys = Object.keys(bagItems);
        let items = {
            bags: 0,
            childEquipment: 0,
            oversizeItem: 0
        };
        let isEmpty = true;
        for (let i = 0; i < keys.length; i++) {
            if (bagItems[keys[i]] !== 0) {
                isEmpty = false;
            }
        }
        if (isEmpty) {
            return items;
        }
        return bagItems;
    }

    BagsClassificationToBagItems(bagsClassification) {
      // "bagsClassification": [
      //     {
      //       "Type": "Bags",
      //       "Count": 1
      //     },
      //     {
      //       "Type": "ChildEquipment",
      //       "Count": 1
      //     },
      //     {
      //       "Type": "OversizeItem",
      //       "Count": 1
      //     }
      //   ]
      const bagItems: BagItems = { bags: 0, childEquipment: 0, oversizeItem: 0 };
      if (!bagsClassification) {
        bagItems.bags = 1;
        return bagItems;
      }

      for (let i = 0; i < bagsClassification.length; i++) {
          const element = bagsClassification[i];
          const itemType = ItemTypes[element.type];
          bagItems[itemType] = element.count;
      }

      return bagItems;
    }

    bagItemsToBagsClassification(bagItems: BagItems) {
        const enums = { bags: 'Bags', childEquipment: 'ChildEquipment', oversizeItem: 'OversizeItem' }
        // const bagsClassification = Object.keys(bagItems).map(item => {
        //     return {
        //         Type: enums[item],
        //         Count: bagItems[item]
        //    }
        // });
        // return bagsClassification;
        return [
            {
              "Type": "Bags",
              "Count": bagItems.bags
            },
            {
              "Type": "ChildEquipment",
              "Count": bagItems.childEquipment
            },
            {
              "Type": "OversizeItem",
              "Count": bagItems.oversizeItem
            }
          ]
    }
}
